import {
  FC,
  HTMLProps,
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
} from 'react'
import { Heading, StyledSection } from './styled'
import { Container, type Mode } from 'components/container'
import { useNavigationContext } from 'context/navigation-context'

type Props = {
  heading?: string
  className?: string
  containerType?: Mode
  beforeTitle?: ReactNode
}

const ContentContainer = ({
  containerType,
  children,
}: PropsWithChildren<{ containerType: Props['containerType'] }>) => {
  if (!containerType) {
    return <>{children}</>
  }

  return <Container $mode={containerType}>{children}</Container>
}

export const Section: FC<
  PropsWithChildren<Props> & HTMLProps<HTMLDivElement>
> = ({
  heading,
  className,
  containerType,
  children,
  beforeTitle = null,
  as,
  ...props
}) => {
  const sectionRef = useRef<HTMLDivElement>(null)
  const { addSection } = useNavigationContext()

  useEffect(() => {
    const title = heading || sectionRef.current?.getAttribute('aria-label')

    if (sectionRef.current && title) {
      addSection({ element: sectionRef.current, title })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [heading])

  return (
    <StyledSection {...props} ref={sectionRef} className={className}>
      {!!heading && (
        <Container $mode="text">
          {beforeTitle}
          <Heading>{heading}</Heading>
        </Container>
      )}
      <ContentContainer containerType={containerType}>
        {children}
      </ContentContainer>
    </StyledSection>
  )
}
